import React from "react";
import { useMap } from "react-map-gl";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Button } from "@mui/material";

import { travelTimeFocusPointAtom, travelTimeFocusPointModeAtom } from './atoms'
import { popupAtom } from "../../../popups/popupAtom";

export default function TravelTimeRefocusButton() {
	const { map } = useMap();
  const setFocusPoint = useSetRecoilState(travelTimeFocusPointAtom)
  const [refocusMode, setRefocusMode] = useRecoilState(travelTimeFocusPointModeAtom)
  const setPopup = useSetRecoilState(popupAtom);

  const enterSetFocusPointMode = (event) => {
  	map.once('click', setFocusPointOnClick)
  	map.getCanvas().style.cursor = "crosshair";
  	setPopup(null);
  	setRefocusMode(true)
  }

  const setFocusPointOnClick = (event) => {
  	if (event.lngLat) {
  		setFocusPoint([
  			event.lngLat.lng,
  			event.lngLat.lat,
  		])
  	}

  	map.getCanvas().style.cursor = "";
  	setRefocusMode(false)
  	event.originalEvent.stopImmediatePropagation()
  }

  return (
    <Button
    	variant={refocusMode ? "contained" : "outlined"}
    	onClick={enterSetFocusPointMode}
    	sx={{
    		ml: 3,
    		mt: 1,
    		mb: 2,
    	}}>
      Set Starting Point
		</Button>
  )
}

